import axios from 'axios';

const ginInstance = axios.create({
  timeout: 10000,
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json'
  }
})

function request(options) {
  return ginInstance(options)
    .then(res => {
      return res.data;
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export default request;
